export default "<p>multiproperty works!</p>\r\n";